<template>
  <div class="warning-box d-flex">
    <div class="warning-box--icon">
      <i class="zmdi zmdi-alert-circle"></i>
    </div>
    <div>
      <h3 class="warning-box--messaging">Your submission contains potential duplicate information.</h3>
      <p>
        If you would like to reach out to the organization who may have duplicate information, their contact info can be found by reviewing the potential duplicate information in the table below.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WarningMessage',
}
</script>